import { mapColorsToScheme } from '../../../../lib';
export default (function (siteVariables) {
    var colorVariant = 500;
    return {
        colors: mapColorsToScheme(siteVariables, colorVariant),
        color: siteVariables.black,
        backgroundColor: siteVariables.bodyBackground,
        padding: '1em',
        borderRadius: 0,
        boxShadowColor: 'rgba(34,36,38,.15)',
    };
});
